import {getValueOrDash} from "../../../helpers/defaultReturnFunction";
import {impexDateFormat} from "../../../manager/dateManager";
import {dateType} from "./fields";

const forecastTableCustomCell = (cell) => {
  if (cell.value) {
    if (dateType.includes(cell.column.id)) {
      return impexDateFormat(cell.value);
    } else return `${cell.value}`;
  } else return `${getValueOrDash(cell.value)}`;
};

export const forecastDefaultColumn = {
  Cell: forecastTableCustomCell,
};
